import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class WellpassBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Wellpass;
  get Icon(): React.ComponentType<SvgIconProps> {
    return SportsGymnasticsIcon;
  }
}
